import { render, staticRenderFns } from "./SimpleInvoicePopup.vue?vue&type=template&id=010b3796"
import script from "./SimpleInvoicePopup.vue?vue&type=script&lang=js"
export * from "./SimpleInvoicePopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports